<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { productMethods, productComputed, cartMethods, cartComputed } from "@/state/helpers";

export default {
  page: {
    title: "News Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,StarRating },
  data() {
    return {
      title: "News Details",
      productDetail:null,
      items: [
        {text: "Ecommerce",href: "/",},
        {text: "Service Detail",active: true,},
      ],
      qty:1,
      vendor_id:'',
      loader:false,
      userData: JSON.parse(localStorage.getItem("user")),
      review:"",
      reviews:[],
    };
  },
  mounted() {
    this.productDetail = this.products.filter((product) => {
      return product.product_id == parseInt(this.$route.query.id);
    });
    this.vendor_id=this.productDetail[0].user_id;
    this.fetchCarts();
    this.fetchReviews();
  },
  computed: {
    ...productComputed,
    ...cartComputed,
  },
  methods: {
    ...productMethods,
    ...cartMethods,
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async AddtoCart(){
      this.loader=true;
      let formData = new FormData();
      formData.append("product_id", this.$route.query.id);
      formData.append("quantity", this.qty);
      formData.append("vendor_id", this.vendor_id);
      let url = "/addtocart";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.$toast.success("Item Added to Cart");
        this.qty="1";
        this.loader=false;
        this.$router.push({name: "cart",})
       }
      });
    },
    async fetchReviews(){
      let formData = new FormData();
      formData.append("product_id", this.$route.query.id);
      let url = "/fetchreviews";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.reviews=response.data.reviews;
       }
      });
    },
    async addReview(){
      this.loader=true;
      let formData = new FormData();
      formData.append("product_id", this.$route.query.id);
      formData.append("review", this.review);
      let url = "/savereview";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.$toast.success("Review Added");
        this.loader=false;
        this.review='';
        this.fetchReviews();
       }
      });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="shadow-lg">
          <div class="p-3">
            <b-button @click="$router.go(-1)" class="bg-danger">
              <i class='mdi mdi-arrow-left'></i>
              <span class="text-capitalize ml-2">Go Back</span>
            </b-button> <br><br>
            <div class="row">
              <div class="col-xl-5 col-sm-4">
                <img :src="getFiles(productDetail[0].photo)" class="img-fluid mx-auto d-block"/>
               </div>
               <div class="col-xl-7 col-sm-8">
                <div class="mt-3">
                  <h4 class="mt-1 mb-3">{{ productDetail[0].name }}</h4>
                  <h6 class="mb-2">Category : <b class="">{{ productDetail[0].category.name }}</b></h6>
                  <h5 class="mb-2">Price : <b>{{ commas(productDetail[0].price) }} AED</b></h5>

                  <div class="row" v-if="userData">
                    <!-- <div class="col-4 col-md-3"><b-form-spinbutton wrap min="1" max="10" v-model="qty"></b-form-spinbutton></div> -->
                    <div class="col-6 col-md-3"><b-button  @click="AddtoCart()" variant="success"><b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/> Book Now</b-button></div>
                  </div>
                  <div v-else>
                    <router-link :to="{ path: '/login',}">
                      <span class="bg-success text-white p-2 rounded-2"><i class="mdi mdi-account-circle"></i> Login </span><br>
                      <br><i class="small text-dark">First login to add to your cart</i>
                    </router-link>
                  </div>
                  <h6 class="mt-3"> Description:<p class="text-muted mb-4">{{productDetail[0].description}}</p></h6>
                  <router-link :to="{ path: '/shop', query: { id: productDetail[0].vendor.user_id }}">
                    <span class="bg-dark small text-white p-2 rounded-2">Vendor: {{ productDetail[0].vendor.business_name }} <i class="fas fa-map-marker-alt"></i>  {{ productDetail[0].vendor.business_address }} <i class="fas fa-phone-alt"></i> {{ productDetail[0].vendor.business_contact }}</span>
                  </router-link>
                </div>
              </div> 
            </div>
            <br><br>
            <div class="shadow-lg">
              <div class="card-body">
                <h4 class="mt-0">Reviews</h4>
                <ul class="list-unstyled mt-1" v-for="item in reviews" :key="item.id">
                <b-media tag="li">
                  <template #aside>
                    <span v-if="item.addedby=='Guest User'" class="h2 bg-danger text-white p-2 me-1 rounded-3"><b>G</b></span>
                    <span v-else class="h2 bg-danger text-white p-2 me-1 rounded-3"><b>{{ item.addedby.first_name.charAt(0) }}</b></span>
                  </template>
                  <h5 v-if="item.addedby=='Guest User'" class="my-0">Guest User</h5>
                  <h5 v-else class="my-0">{{item.addedby.first_name}}</h5>
                  <span v-html="item.comment"></span>
                  <i class="text-black">{{item.addedon}}</i>
                </b-media>
                </ul>

                  <form @submit.prevent="addReview">
                    <label class="mt-2">Enter Review</label>
                    <tinymce id="d1" v-model="review"></tinymce>
                    <b-button type="submit" class="btn mt-1 w-30" variant="primary"> <b-spinner v-if="loader" small/><i v-else class="fas fa-check-circle"></i> Submit</b-button>
                  </form>
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
